import React from 'react';
import { useEffect } from 'react';
import { api } from 'services';
import { useState } from 'react';
import { Link, useLocation, useRouteMatch, withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Card, Row, Col, Modal, Button } from 'react-bootstrap';
import ListingActions from 'components/ListingActions';
import ActionsFormExpenseDescriptions from 'components/Actions/Form/ExpenseDescriptions';

function ActionAttachingModal(props) {
  const [modal, setModal] = useState(props.modal);
  const [data, setData] = useState({ data: [] });
  const [companies, setCompanies] = useState([]);
  const [attachingFile, setAttachingFile] = useState({
    status: false,
    id: null,
  });
  const defaultFilters = {
    status_id: 13,
    __fiscal_year: '',
    __period_id: '',
    per_page: 10,
    page:1
  };
  const [filters, setFilters] = useState(defaultFilters);
  const { t } = useTranslation();

  useEffect(() => {
      api.get('companies/all').then(({ data }) => setCompanies(data));
      api
      .get('actions', { params: { ...filters } })
      .then(({ data }) => setData(data));
  }, []);

  useEffect(()=>{
    api
    .get('actions', { params: { ...filters } })
    .then(({ data }) => setData(data));
  },[filters]);

  const exitModal = () => {
    setModal(false);
  };

  const modalBtn = () => {
    setModal(true);
  };

  const cleanNFexplorer = () => {
    setModal(false);
    setAttachingFile({ status: false, id: null });
  };

  const handleFilterChange = (new_filters, reset = false) => {
    let f = { ...filters, ...new_filters };

    if (reset) f = { ...defaultFilters, ...new_filters };

    setFilters(f);
  };

  return (
    <>
      <Button
        variant="light"
        alt={t('label: nf link')}
        size="sm"
        title={t('label:nf link')}
        onClick={modalBtn}
      >
        <i className="fas fa-link" />
      </Button>
      <Modal size="xl" show={modal} onHide={exitModal}>
        <Modal.Header closeButton />
        <Modal.Body>
          {!attachingFile.status ? (
            <ListingActions
              data={data}
              filters={[
                {
                  name: 'company',
                  key: '__company_id',
                  options: companies.map((company) => ({
                    label: company.alias,
                    value: company.id,
                  })),
                },
              ]}
              stateFilters={filters}
              location
              isAtacchingFiles
              attachingFile={setAttachingFile}
              handleFilterChange={handleFilterChange}
            />
          ) : (
            <ActionsFormExpenseDescriptions
              cleanNFexplorer={cleanNFexplorer}
              fileId={props.fileId}
              showModalFromFiles
              actionId={attachingFile.id}
              expenseDescriptions={[]}
              handleFilterChange={handleFilterChange}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default withRouter(ActionAttachingModal);
